import { defineMessages } from 'react-intl'

export default defineMessages({
  securityHeading: {
    id: 'accountSettings.securitySection.heading',
    defaultMessage: 'Security',
  },
  turnOn: {
    id: 'accountSettings.securitySection.turnOn',
    defaultMessage: 'Turn on {optionLabel}',
  },
})
